(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[803],{

/***/ 91221:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/category/[slug]",
      function () {
        return __webpack_require__(85249);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ARTICLE_RESULT_FIRST_PAGE_AMOUNT": function() { return /* binding */ ARTICLE_RESULT_FIRST_PAGE_AMOUNT; },
/* harmony export */   "ARTICLE_RESULT_REST_PAGES_AMOUNT": function() { return /* binding */ ARTICLE_RESULT_REST_PAGES_AMOUNT; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_lab_Pagination__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72221);
/* harmony import */ var components_CMS_ArticleListSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96386);
/* harmony import */ var components_CMS_ArticleResultLanding__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31819);
/* harmony import */ var modules_ContentHubContainer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26877);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31211);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_7__);










var __N_SSP = true;
var ARTICLE_RESULT_FIRST_PAGE_AMOUNT = 14;
var ARTICLE_RESULT_REST_PAGES_AMOUNT = 18;
var ArticlesByCategory = function(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var articles = props.articles, categoriesOnMenu = props.categoriesOnMenu, title = props.title, query = props.query, pageCount = props.pageCount, promotion = props.promotion, slug = props.slug, metaTitle = props.metaTitle, metaDescription = props.metaDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(modules_ContentHubContainer__WEBPACK_IMPORTED_MODULE_6__/* .ContentHubContainer */ ._, {
        categories: categoriesOnMenu,
        selectedCategorySlug: slug,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
                title: metaTitle !== null && metaTitle !== void 0 ? metaTitle : undefined,
                description: metaDescription !== null && metaDescription !== void 0 ? metaDescription : undefined,
                noindex: true,
                nofollow: true,
                openGraph: {
                    title: metaTitle !== null && metaTitle !== void 0 ? metaTitle : undefined,
                    description: metaDescription !== null && metaDescription !== void 0 ? metaDescription : undefined,
                    type: "article"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Typography__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    variant: "h4",
                    component: "h1",
                    children: title
                })
            }),
            query.page === 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CMS_ArticleResultLanding__WEBPACK_IMPORTED_MODULE_5__/* .ArticleResultLanding */ .E, {
                articles: articles,
                promotion: promotion
            }),
            query.page > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CMS_ArticleListSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                articles: articles
            }),
            pageCount > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().pagination),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Pagination__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    count: pageCount,
                    page: +query.page || 1,
                    variant: "outlined",
                    shape: "rounded",
                    color: "primary",
                    onChange: function(e, value) {
                        query.page = value;
                        router.push({
                            pathname: location.pathname,
                            query: query
                        });
                    }
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ArticlesByCategory);


/***/ }),

/***/ 31211:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__5dTrH","pagination":"style_pagination__tFUi9"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,4577,8612,7982,9774,2888,179], function() { return __webpack_exec__(91221); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);